import ListUsersB2b from '../../components/ListUsersB2b';
import SEO from 'client/components/SEO';

 function EspaceB2b() {
  return (
    <div>
        <SEO title="User B2b" description="Utilisateurs B2B" />
<h2 className='mt-5'>Utilisateurs B2B</h2>
      <ListUsersB2b />
    </div>
  );
}

export default EspaceB2b